import { CounterTable, Counter as CounterType } from "@/types/pos/counter";
import { ApiResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";

export const Counter = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getCounters: builder.query<
        CounterTable,
        {
          query: string;
          org_id?: number;
        }
      >({
        query: (searchCretiria) => ({
          url: `/pos/counters?${searchCretiria.query}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Counter"],
        transformResponse: (resp: CounterTable) => {
          const { data, ...rest } = resp;

          const updatedData = data.map((item) => ({
            ...item,
            staff: item.staff.filter((staffMember) => staffMember.id !== null),
          }));

          return {
            ...rest,
            data: updatedData,
          };
        },
      }),
      createCounters: builder.mutation<ApiResponse, CounterType>({
        query: (counter) => ({
          url: `/pos/counters`,
          method: "POST",
          body: counter,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Counter"],
      }),
      updateCounters: builder.mutation<ApiResponse, CounterType>({
        query: (counter) => ({
          url: `/pos/counters/${counter.id}`,
          method: "PUT",
          body: counter,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Counter"],
      }),
      deleteCounter: builder.mutation<ApiResponse, number>({
        query: (id) => ({
          url: `/pos/counters/${id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["Counter"],
      }),
      getCounterById: builder.query<CounterType, number>({
        query: (id) => ({
          url: `/pos/counters/${id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["Counter"],
      }),
    };
  },
});

export const {
  useGetCountersQuery,
  useGetCounterByIdQuery,
  useCreateCountersMutation,
  useUpdateCountersMutation,
  useDeleteCounterMutation,
} = Counter;
